<template>
  <!-- 底部导航 -->
  <div class="ersoncal-Navition" v-if="snatus == '1' || snatus == '2' || snatus == '3'">
    <router-link :to="{path: 'shopmall'}">
      <div class="ersoncal-Navition-content ersoncal-Navition-hoge">
        <img src="../../public/obraoag/mallseon.png" alt="" v-if="snatus == '1'">
        <img src="../../public/obraoag/malldelt.png" alt="" v-else>
        <span :class="snatus == '1' ? 'bonaed' : ''">首页</span>
      </div>
    </router-link>
    <router-link :to="{path: 'ShopCart'}">
      <div class="ersoncal-Navition-content ersoncal-Navition-cork">
        <img src="../../public/obraoag/shrtcted.png" alt="" v-if="snatus == '2'">
        <img src="../../public/obraoag/shrtault.png" alt="" v-else>
        <span :class="snatus == '2' ? 'bonaed' : ''">购物车</span>
      </div>
    </router-link>
    <router-link :to="{path: 'ersoncal'}">
      <div class="ersoncal-Navition-content ersoncal-Navition-size">
        <img src="../../public/obraoag/persault.png" alt="" v-if="snatus == '3'">
        <img src="../../public/obraoag/perscted.png" alt="" v-else>
        <span :class="snatus == '3' ? 'bonaed' : ''">个人中心</span>
      </div>
    </router-link>
  </div>
  <div class="ersoncal-Navition" v-else-if="snatus == '4' || snatus == '5' || snatus == '6'">
    <router-link :to="{path: 'pointsal'}">
      <div class="ersoncal-Navition-content ersoncal-Navition-hoge">
        <img src="../../public/obraoag/mallseon.png" alt="" v-if="snatus == '4'">
        <img src="../../public/obraoag/malldelt.png" alt="" v-else>
        <span :class="snatus == '4' ? 'bonaed' : ''">首页</span>
      </div>
    </router-link>
    <router-link :to="{path: 'inalch',query: {pembules: '0'}}">
      <div class="ersoncal-Navition-content ersoncal-Navition-sect">
        <img src="../../public/obraoag/select.png" alt="" v-if="snatus == '5'">
        <img src="../../public/obraoag/member.png" alt="" v-else>
        <span :class="snatus == '5' ? 'bonaed' : ''">会员</span>
      </div>
    </router-link>
    <router-link :to="{path: 'peracter'}">
      <div class="ersoncal-Navition-content ersoncal-Navition-size">
        <img src="../../public/obraoag/persault.png" alt="" v-if="snatus == '6'">
        <img src="../../public/obraoag/perscted.png" alt="" v-else>
        <span :class="snatus == '6' ? 'bonaed' : ''">个人中心</span>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    snatus: String
  },
}
</script>

<style scoped>
  @import "../views/obraocs/botgaion.css";
</style>